import React from "react";
import logo from "@assets/images/main-logo.svg";
import Profile from "../Profile/index";
import Notification from "../Notification/index";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputAdornment from "@mui/material/InputAdornment";
// import { superAdminRoutes } from "@";
import { getUserType } from "store/userType";
import IconButton from "@mui/material/IconButton";
import { getFromStorage } from "utils/storage";
import { useState } from "react";
import { generalStore } from "store/generalStore";
import { commonGreData } from "data/greData/commonGreData";
import useHeader from "view-models/Common/Header/useHeader";
import { useHistory, useLocation } from "react-router-dom";
import { commonData } from "data/CommonDataPoint";

function Header({
  isMenuOpen,
  menuOpenHandle,
  menuOpenHandleMobile,
  isMenuOpenMobile,
  setIsMenuOpenMobile,
}) {
  const {
    projectListData,
    projectMenu,
    selectedProject,
    handleSelectChange,
    handleProjectMenu,
    setProjectMenu,
    handleSelectMobileChange,
  } = useHeader();

  const isUserType = getUserType((state) => state.isUserType);
  const history = useHistory();
  const location = useLocation();

  const helloState = location.state;
  // const [age, setAge] = React.useState("");

  // const disabledPaths = [
  //   "/CRMUser/dashboard",
  //   "/VerticalHead/dashboard",
  //   "/VerticalHead/apartment-listing",
  //   "/VerticalHead/booking",
  //   "/VerticalHead/payment",
  //   "/VerticalHead/ebw-lists",
  //   "/VerticalHead/customer",
  //   "/SubVerticalHead/dashboard",
  //   "/SubVerticalHead/apartment-listing",
  //   "/SubVerticalHead/booking",
  //   "/SubVerticalHead/payment",
  //   "/SubVerticalHead/ebw-lists",
  //   "/SubVerticalHead/customer",
  //   "/ProjectHead/dashboard",
  //   "/ProjectHead/apartment-listing",
  //   "/ProjectHead/booking",
  //   "/ProjectHead/payment",
  //   "/ProjectHead/ebw-lists",
  //   "/ProjectHead/customer",
  //   "/RegionalHead/dashboard",
  //   "/RegionalHead/apartment-listing",
  //   "/RegionalHead/booking",
  //   "/RegionalHead/payment",
  //   "/RegionalHead/ebw-lists",
  //   "/RegionalHead/customer",
  //   "/ClosingManager/dashboard",
  //   "/ClosingManager/apartment-listing",
  //   "/ClosingManager/booking",
  //   "/ClosingManager/payment",
  //   "/ClosingManager/ebw-lists",
  //   "/ClosingManager/customer",
  //   "/GRE/customer-search",
  //   "/GRE/customer",
  //   "/ClosingTeamLead/assign-customer",
  //   "/ClosingTeamLead/customer"
  // ];

  // const currentPath = window.location.pathname;

  // const disabled = disabledPaths.includes(currentPath);

  const disabled =
    // (window.location.pathname !== "/ClosingManager/choose-apartment" && helloState?.isInventory) &&
    window.location.pathname !== "/admin/customer-search" &&
    window.location.pathname !== "/admin/customers" &&
    window.location.pathname !== "/admin/booking" &&
    window.location.pathname !== "/admin/dashboard" &&
    window.location.pathname !== "/admin/ebwlist" &&
    window.location.pathname !== "/admin/payment" &&
    window.location.pathname !== "/admin/assign-customer" &&
    window.location.pathname !== "/admin/apartment-listing" &&
    window.location.pathname !== "/CRMUser/dashboard" &&
    window.location.pathname !== "/VerticalHead/dashboard" &&
    window.location.pathname !== "/VerticalHead/apartment-listing" &&
    window.location.pathname !== "/VerticalHead/booking" &&
    window.location.pathname !== "/VerticalHead/payment" &&
    window.location.pathname !== "/VerticalHead/ebw-lists" &&
    window.location.pathname !== "/VerticalHead/customer" &&
    window.location.pathname !== "/SubVerticalHead/dashboard" &&
    window.location.pathname !== "/SubVerticalHead/apartment-listing" &&
    window.location.pathname !== "/SubVerticalHead/booking" &&
    window.location.pathname !== "/SubVerticalHead/payment" &&
    window.location.pathname !== "/SubVerticalHead/ebw-lists" &&
    window.location.pathname !== "/SubVerticalHead/customer" &&
    window.location.pathname !== "/ClosingTeamLead/dashboard" &&
    window.location.pathname !== "/ClosingTeamLead/apartment-listing" &&
    window.location.pathname !== "/ClosingTeamLead/booking" &&
    window.location.pathname !== "/ClosingTeamLead/payment" &&
    window.location.pathname !== "/ClosingTeamLead/ebw-lists" &&
    window.location.pathname !== "/ClosingTeamLead/customer" &&
    window.location.pathname !== "/ClosingTeamLead/assign-customer" &&
    window.location.pathname !== "/SourcingTeamLead/dashboard" &&
    window.location.pathname !== "/SourcingTeamLead/apartment-listing" &&
    window.location.pathname !== "/SourcingTeamLead/booking" &&
    window.location.pathname !== "/SourcingTeamLead/payment" &&
    window.location.pathname !== "/SourcingTeamLead/ebw-lists" &&
    window.location.pathname !== "/SourcingTeamLead/customer" &&
    window.location.pathname !== "/SourcingTeamLead/assign-customer" &&
    window.location.pathname !== "/ProjectHead/dashboard" &&
    window.location.pathname !== "/ProjectHead/apartment-listing" &&
    window.location.pathname !== "/ProjectHead/booking" &&
    window.location.pathname !== "/ProjectHead/payment" &&
    window.location.pathname !== "/ProjectHead/ebw-lists" &&
    window.location.pathname !== "/ProjectHead/customer" &&
    window.location.pathname !== "/RegionalHead/dashboard" &&
    window.location.pathname !== "/RegionalHead/apartment-listing" &&
    window.location.pathname !== "/RegionalHead/booking" &&
    window.location.pathname !== "/RegionalHead/payment" &&
    window.location.pathname !== "/RegionalHead/ebw-lists" &&
    window.location.pathname !== "/RegionalHead/customer" &&
    window.location.pathname !== "/ClosingManager/dashboard" &&
    window.location.pathname !== "/ClosingManager/apartment-listing" &&
    window.location.pathname !== "/ClosingManager/booking" &&
    window.location.pathname !== "/ClosingManager/payment" &&
    window.location.pathname !== "/ClosingManager/ebw-lists" &&
    window.location.pathname !== "/ClosingManager/customer" &&
    window.location.pathname !== "/SourcingManager/dashboard" &&
    window.location.pathname !== "/SourcingManager/apartment-listing" &&
    window.location.pathname !== "/SourcingManager/booking" &&
    window.location.pathname !== "/SourcingManager/payment" &&
    window.location.pathname !== "/SourcingManager/ebw-lists" &&
    window.location.pathname !== "/SourcingManager/customer" &&
    window.location.pathname !== "/GRE/customer-search" &&
    window.location.pathname !== "/GRE/customers" &&
    window.location.pathname !== "/admin/user-request" &&
    window.location.pathname !== "/CRMUser/booking" &&
    window.location.pathname !== "/admin/sms-email";

  // window.location.pathname !== "/ClosingTeamLead/customer";

  return (
    <>
      <header className="bs-header">
        <div className="header-logo-wrap">
          <button
            className={`header-menu-btn cm-visible-md ${
              isMenuOpenMobile ? "" : "btn-open"
            }`}
            onClick={() => {
              menuOpenHandleMobile();
              setProjectMenu(false);
            }}
          >
            <span
              className={`icon ${
                isMenuOpenMobile ? "icon-menu" : "icon-close"
              }`}
            ></span>
          </button>
          <button
            className={`header-menu-btn cm-hidden-md ${
              isMenuOpen ? "" : "btn-open"
            }`}
            onClick={menuOpenHandle}
          >
            <span
              className={`icon ${isMenuOpen ? "icon-menu" : "icon-close"}`}
            ></span>
          </button>
          <a href="#" className="header-logo">
            <img src={logo} alt="Mahindra Lifespace" />
          </a>
          {isUserType?.replace(/\s/g, "") == commonData?.closingTeamLeadRole ||
          isUserType?.replace(/\s/g, "") == commonData?.salesRole ||
          isUserType?.replace(/\s/g, "") == commonData?.sourcingManagerRole ||
          isUserType?.replace(/\s/g, "") == commonData?.sourcingTeamLeadRole ||
          isUserType?.replace(/\s/g, "") == commonData?.greRole ||
          isUserType?.replace(/\s/g, "") == commonData?.projectHead ||
          isUserType?.replace(/\s/g, "") == commonData?.regionalHead ||
          isUserType?.replace(/\s/g, "") == commonData?.verticalHead ||
          isUserType?.replace(/\s/g, "") == commonData?.subVerticalHead ||
          isUserType?.replace(/\s/g, "") == commonData?.CRM ||
          isUserType?.replace(/\s/g, "") == commonData?.admin ? (
            <div className="bs-select">
              <FormControl fullWidth>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  disabled={
                    location.pathname ==
                      `/${isUserType?.replace(/\s/g, "")}/choose-apartment` &&
                    helloState?.isInventory
                      ? false
                      : disabled
                  }
                  value={selectedProject}
                  onChange={handleSelectChange}
                  startAdornment={
                    <InputAdornment position="start">
                      <span className="icon icon-project-city"></span>
                    </InputAdornment>
                  }
                  IconComponent={(props) => (
                    <span
                      {...props}
                      className={`cmp-select__icon icon-chevron-down ${props.className}`}
                    ></span>
                  )}
                  MenuProps={{
                    classes: {
                      paper: "bs-select-menu",
                    },
                  }}
                  displayEmpty
                >
                  <MenuItem value="" disabled selected>
                    Select
                  </MenuItem>
                  {projectListData
                    // ?.filter((project) => project?.projectId !== 5)
                    ?.map((project, index) => {
                      return (
                        <MenuItem key={index} value={project?.projectId}>
                          {project?.projectName}
                        </MenuItem>
                      );
                    })}
                  {/* <MenuItem value={1}>Mahindra Vista</MenuItem>
                  <MenuItem value={2}>Mahindra Alcove</MenuItem>
                  <MenuItem value={3}>Mahindra Alcove 2</MenuItem> */}
                </Select>
              </FormControl>
            </div>
          ) : null}
        </div>
        <div className="header-cont-wrap">
          <ul className="sub-menu">
            <li className="sub-menu-item">
              <Profile />
            </li>
            {isUserType?.replace(/\s/g, "") ==
              commonData?.closingTeamLeadRole ||
            isUserType?.replace(/\s/g, "") == commonData?.salesRole ||
            isUserType?.replace(/\s/g, "") == commonData?.sourcingManagerRole ||
            isUserType?.replace(/\s/g, "") ==
              commonData?.sourcingTeamLeadRole ||
            isUserType?.replace(/\s/g, "") == commonData?.greRole ||
            isUserType?.replace(/\s/g, "") == commonData?.projectHead ||
            isUserType?.replace(/\s/g, "") == commonData?.regionalHead ||
            isUserType?.replace(/\s/g, "") == commonData?.verticalHead ||
            isUserType?.replace(/\s/g, "") == commonData?.subVerticalHead ||
            isUserType?.replace(/\s/g, "") == commonData?.CRM ||
            isUserType?.replace(/\s/g, "") == commonData?.admin ? (
              <li className="sub-menu-item project-btn">
                <IconButton
                  className={`bs-btn btn-icon ${projectMenu ? "active" : ""}`}
                  disableRipple
                  onClick={handleProjectMenu}
                >
                  <span className="icon icon-project-city"></span>
                  <span
                    className={`arrow-icon ${
                      projectMenu ? "icon-chevron-up" : "icon-chevron-down"
                    } `}
                  ></span>
                </IconButton>
              </li>
            ) : (
              <></>
            )}

            {isUserType?.replace(/\s/g, "") == commonData?.salesRole && (
              <li className="sub-menu-item">
                <Notification />
              </li>
            )}
          </ul>
        </div>
      </header>
      <div className={`bs-project-menu ${projectMenu ? "active" : ""}`}>
        <ul className="p-list">
          {projectListData
            // ?.filter((project) => project?.projectId !== 5)
            ?.map((project, index) => {
              return (
                <li
                  className="p-item"
                  onClick={() => handleSelectMobileChange(project?.projectId)}
                >
                  <p className="p-text">{project?.projectName}</p>
                  {/* <div className="p-logo-wrap">
                  <img src={logo} alt="" />
                </div> */}
                  <a href="#" className="p-link"></a>
                </li>
              );
            })}
          {/* <li className="p-item">
            <p className="p-text">Mahindra Alcove</p>
            <div className="p-logo-wrap">
              <img src={logo} alt="" />
            </div>
            <a href="#" className="p-link"></a>
          </li>
          <li className="p-item">
            <p className="p-text">Mahindra Lifespace Residential</p>
            <div className="p-logo-wrap">
              <img src={logo} alt="" />
            </div>
            <a href="#" className="p-link"></a>
          </li>
          <li className="p-item">
            <p className="p-text">Mahindra Lifespace Eastern Heights</p>
            <div className="p-logo-wrap">
              <img src={logo} alt="" />
            </div>
            <a href="#" className="p-link"></a>
          </li>
          <li className="p-item">
            <p className="p-text">Mahindra Lifespace Bolvourde court</p>
            <div className="p-logo-wrap">
              <img src={logo} alt="" />
            </div>
            <a href="#" className="p-link"></a>
          </li>
          <li className="p-item">
            <p className="p-text">Mahindra Lifespace Residential</p>
            <div className="p-logo-wrap">
              <img src={logo} alt="" />
            </div>
            <a href="#" className="p-link"></a>
          </li>
          <li className="p-item">
            <p className="p-text">Mahindra Lifespace Eastern Heights</p>
            <div className="p-logo-wrap">
              <img src={logo} alt="" />
            </div>
            <a href="#" className="p-link"></a>
          </li> */}
        </ul>
      </div>
      {projectMenu ? <span className="cm-backdrop"></span> : ""}
    </>
  );
}

export default Header;
